export const REACT_APP_ASSETS_URL = process.env
  .REACT_APP_ASSETS_URL
  ? process.env.REACT_APP_ASSETS_URL
  : "";

export const REACT_APP_MAIANS_TWITTER_URL = process.env
  .REACT_APP_MAIANS_TWITTER_URL
  ? process.env.REACT_APP_MAIANS_TWITTER_URL
  : "";